import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/customer/notes', config);
}

const get = async (id) => {
    return FinanceApi.get('/customer/notes/' + id);
}

const del = async (id) => {
    return FinanceApi.delete('/customer/notes/' + id);
}

const store = async (data) => {
    return FinanceApi.post('/customer/notes/', data);
}

const update = async (id, data) => {
    return FinanceApi.put('/customer/prices/' + id, data);
}
export default {
    get, getAll, store, update, del
}
